export const actions = {
    backToStart: 'Back to Start',
};
